import cn from 'classnames'
import React, { ComponentProps } from 'react'

type DragHandleIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function DragHandleIcon(props: DragHandleIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('DragHandleIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <circle cx="6" cy="3.5" r="1.25" fill={props.fill || '#9CA3AF'} />
      <circle cx="10" cy="3.5" r="1.25" fill={props.fill || '#9CA3AF'} />
      <circle cx="6" cy="8" r="1.25" fill={props.fill || '#9CA3AF'} />
      <circle cx="10" cy="8" r="1.25" fill={props.fill || '#9CA3AF'} />
      <circle cx="6" cy="12.5" r="1.25" fill={props.fill || '#9CA3AF'} />
      <circle cx="10" cy="12.5" r="1.25" fill={props.fill || '#9CA3AF'} />
    </svg>
  )
}
